import React from 'react'
import { usePet } from '../../modules'

const CompleteNDiscard = ({ entry, onClose, close }) => {
    const [{ loading: compLoading }, completeEntry] = usePet('completeEntry', { id: entry?._id }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        onClose()
        close()
    }, manual: true, load: { msg: 'Saving changes...' } })

    return (
        <>
            <button onClick={ completeEntry } disabled={ compLoading } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ entry?.filled ? 'Update' : 'Complete' }</button>
            { !entry?.filled && <button onClick={ completeEntry } disabled={ compLoading } className="text-white mr-2 hisani-btn-green font-medium rounded-lg text-sm px-5 py-2.5 text-center">Discard</button> }
        </>
    )
}

export default CompleteNDiscard